module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jcMmw"))).then(() => parcelRequire('ljYL6'));